module.exports = __webpack_public_path__ + "static/img/bj.c81e8915.svg";